<h2> Call Recordings </h2>
<div [innerHTML]="litOutPut | safeHtml"></div>
<div *ngIf="btnisShowSum">
    <button class="btn btn-primary btn-sm" (click)="summarizeWithAI()"> Summarize with AI</button>
</div>
<div *ngIf="pnlAIOutput">
    <span [innerHTML]="aiSummaryDisplay"></span>
    <div *ngIf="isShowJSONTxt">
        <textarea [(ngModel)]="txtAIOutput" rows="8" class="form-control">
</textarea>

    </div>
    <div>
        <span [innerHTML]="litTranscript"></span>
    </div>
</div>
<div>
    <app-voice-call-log *ngIf="user && adm > 0" [voiceCallId]="id" [user]="user" [isFromRec]="isFromRec"></app-voice-call-log>
</div>
